import { render, staticRenderFns } from "./AddToWishList.vue?vue&type=template&id=77ba9cfa&"
import script from "./AddToWishList.vue?vue&type=script&lang=js&"
export * from "./AddToWishList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bensz/src/FrontendStudios/plentyDevTool/KMSVueTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ba9cfa')) {
      api.createRecord('77ba9cfa', component.options)
    } else {
      api.reload('77ba9cfa', component.options)
    }
    module.hot.accept("./AddToWishList.vue?vue&type=template&id=77ba9cfa&", function () {
      api.rerender('77ba9cfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js-custom/src/app/components/item/AddToWishList.vue"
export default component.exports